// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__sZ6Cg","adminContainer":"styles_adminContainer__IzCf-","adminContent":"styles_adminContent__l49hy"};